import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-account-exists',
    templateUrl: './account-exists.component.html',
    styleUrls: ['./account-exists.component.scss'],
    standalone: false
})
export class AccountExistsComponent {

  llttfpage=true
  constructor(private route:ActivatedRoute) { }

  ngOnInit(){
    this.route.params.subscribe(params => {
      if(params['programname'] == 'bb')
        {
            this.llttfpage=false
        }
    })
  }

}
